export enum OrderPriority {
    Normal = 1,
    Stat = 2,
    Initial = 3,
    Regular = 4,
    Urgent = 5
}